module.exports = __webpack_public_path__ + "img/TR-Off-3.29378c18.gif";